import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=4b7c19a3&"
import script from "./CustomTable.vue?vue&type=script&lang=ts&"
export * from "./CustomTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports